import Column from '@components/column'
import {
  StyleBannerWrapper,
  StyleBannerCurrentBalanceWrapper,
  StyleBannerOtherInfoWrapper,
  StyleUserInfoCard,
  StyleBankInfoCard,
} from './style'
import Image from '@components/image'
import { useSelector } from 'react-redux'
import Typography from '@components/typography'
import Row from '@components/row'
import Svg from '@components/svg'
import { useState } from 'react'
import WalletImg from './wallet.png'
const Info = () => {
  const { data: user } = useSelector((state: any) => state.user)
  const [visible, setVisible] = useState<boolean>(false)
  return (
    <Column bg="white" styleColumn="border-radius:8px;padding:20px;">
      <StyleBannerWrapper>
        <StyleBannerOtherInfoWrapper>
          <StyleUserInfoCard>
            <Image
              src={`${process.env.BUCKET_URL}/${user?.avatar}`}
              fallbackType="user"
            />
            <Column rowGap={5}>
              <Typography content={user?.name} size={16} />
              <Row colGap={5}>
                <Typography
                  content={`+${user?.countryCode}`}
                  size={14}
                  tc="text100"
                />
                <Typography content={user?.phoneNo} size={14} tc="text100" />
              </Row>
              <Typography content={user?.email} size={14} tc="text100" />
            </Column>
          </StyleUserInfoCard>
          <StyleBankInfoCard>
            <Row justifyContent="space-between" alignItems="center">
              <Typography
                content={user?.infos?.bankDetails?.bankName}
                size={14}
              />
              <Column onClick={() => setVisible(!visible)}>
                <Svg svg={!!visible ? 'crossVisible' : 'visible'} />
              </Column>
            </Row>
            <Typography
              content={
                !!visible
                  ? user?.infos?.bankDetails?.accountNo
                  : 'XXXXXXXXXXXXXXXXXX'
              }
              size={14}
            />
            <Typography
              content={user?.infos?.bankDetails?.accountHolderName}
              size={14}
            />
          </StyleBankInfoCard>
        </StyleBannerOtherInfoWrapper>
        <StyleBannerCurrentBalanceWrapper>
          <Column rowGap={15} styleColumn="margin-left:15px;">
            <Typography content="Current Balance" tc="primary" size={16} />
            <Typography
              content={`Rs.3000`}
              tc="primary"
              size={24}
              weight={600}
            />
          </Column>
          <Image src={WalletImg} />
        </StyleBannerCurrentBalanceWrapper>
        <StyleBannerOtherInfoWrapper>
          <Row
            bg="primary300"
            justifyContent="space-between"
            alignItems="center"
            styleRow="padding:10px 15px;border-radius:8px;height:84px"
          >
            <Typography content="Total Earning" tc="primary" size={14} />
            <Typography content={`Rs.30000`} tc="primary" weight={600} />
          </Row>
          <Row
            bg="yellow250"
            justifyContent="space-between"
            alignItems="center"
            styleRow="padding:10px 15px;border-radius:8px;height:84px;"
          >
            <Typography content="Total Withdrawal" tc="primary" size={14} />
            <Typography content={`Rs.30000`} tc="primary" weight={600} />
          </Row>
        </StyleBannerOtherInfoWrapper>
      </StyleBannerWrapper>
    </Column>
  )
}

export default Info
